<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		zzs,
		editzzs,
		editqysds,
		taxeditqysds,
		cwbb,
		editcwbb,
		sysYhsSm,
		edityhs,
		fccztd,
		editfccztds,
		hjbhs,
		edithbs,
		taxyhs,
		shenbaoContent,
		queryCcxwsPolicy,
		editCcxwsPolicy,
		taxeditzzs,
		getHuizjigou,
		querywhsy,
		preservationwhsy,
		queryty,
		preservationty,
		editcbj,
		queryDiaLogInfo,
		saveDiaLogInfo,
		get_info,
		save_info,
		tripartite_agreement_query,
		tripartite_agreement_delete,
		tripartite_agreement_save,
		tripartite_agreement_update
	} from '../../../../../api/organization.js';
	import diguizi from './diguizj/index.vue';
	export default {
		props: {
			ContentsSettingdiag: {
				type: Boolean,
				default: false
			},
			tableDatabody: {
				type: Array,
				default: getdata().tableDatabody
			}
		},
		components: {
			diguizi
		},
		data: function() {
			return {
				formdataGeneralx: getdata().formdataGeneralx,
				formlistGeneralx: getdata().formlistGeneralx,
				Generalx: false,
				assist: false,
				assvalue: [],
				asslist: [],
				sellist: [],
				headDatabody: getdata().headDatabody,
				//各类弹框diag
				//编辑企业所得税
				ids: {},
				year: [{
						value: '1',
						label: '月'
					},
					{
						value: '2',
						label: '季'
					},
					{
						value: '4',
						label: '年'
					}
				],
				checked: '',

				updatecompanydiag: false,
				updatecompanyformlist: getdata().updatecompanyformlist,
				updatecompanyformdata: getdata().updatecompanyformdata,
				shenbaodata: getdata().shenbaodata,
				suosq: this.$getdefultMonth(),
				//编辑印花税
				updateyhsdiag: false,
				headDatayhs: getdata().headDatayhs,
				tableDatayhs: getdata().tableDatayhs,
				sbboxdata: [{}, {}, {}, {}, {}, {}],
				//消费税
				tableDataxfs: getdata().tableDataxfs,
				optionxfs: JSON.parse(JSON.stringify(this.$optionxfs)),
				//编辑房产城镇土地使用税
				updatehouse: false,
				shifbs: '',
				shuiBtype: '',
				headDatahouse: getdata().headDatahouse,
				tableDatahouse: [{}],
				//编辑环境保护税
				times: ['年', '季', '月'],
				updatehjdiag: false,
				headDatahj: getdata().headDatahj,
				tableDatahj: [{}],
				//编辑财务报表
				listou: {
					time: [],
					index: '',
					radio: '',
					huizsb: '',
					radio2: '0',
					input: '',
					radio1: null
				},
				updatecwdiag: false,
				DisabilityItime: [],
				WHtableData: [],
				tablekey: 0,
				XYheadData: getdata().XYheadData,
				headDatacw: getdata().headDatacw,
				tableDatacw: getdata().tableDatacw,
				XYpagination: getdata().pagination,
				editProtocolNumber:false,
				protocolNumberFormList:getdata().protocolNumberFormList,
				protocolNumberFormData:getdata().protocolNumberFormData,
				//编辑增值税
				updatezzsdiag: false,
				something: [{
						label: '无需',
						value: '0'
					},
					{
						label: '汇总机构',
						value: '1'
					},
					{
						label: '分支机构',
						value: '2'
					}
				],
				//对应汇总机构
				hzdiag: false,
				headDatahz: getdata().headDatahz,
				tableDatahz: [{}],
				//配置减征政策
				jzdiag: false,
				formlistjz: getdata().formlistjz,
				formdatajz: {},
				//残保金
				DisabilityI: false,
				headDatacbj: getdata().headDatacbj,
				tableDatacb: getdata().tableDatacb,
				//文化事业建设
				ConstructionCCU: false,
				formlistConstruction: getdata().formlistConstruction,
				formdataConstruction: getdata().formdataConstruction,
				//通用申报
				GeneralD: false,
				headDatacty: getdata().headDatacty,
				tableDataty: getdata().tableDataty,
				formdataGeneralD: getdata().formdataGeneralD,
				formlistGeneralD: getdata().formlistGeneralD,
				titles: '',
				title: "",
				radioKey: false,
				ConfigureProtocolNumber:false,
				radioKey1: false,
				radioKey2: false,
				radioKey3: false,
				radioKey4: false,
				radioKey5: false,
				radioKey6: false,
				radio1: {},
				radio2: {},
				radio3: {},
				radio4: {},
				radio5: {},
				radio6: {},
				radio7: '',
				radio8: '',
				radio9: {},
				zim: false,
				choosedjindex: null,
				shui: {
					sbid: '',
					szid: ''
				},
				radio: {
					option5: '0',
					option6: ''
				},
				stacid: '',
				yhs: [
					[],
					[{
							name: '年度',
							id: '4'
						},
						{
							name: '季度',
							id: '2'
						},
						{
							name: '次',
							id: '0'
						}
					]
				],
				isshas: true
			};
		},

		watch: {
			'formdatajz.benqsfsyxwqy': function(indexVal, oldVal) {
				if (indexVal == 'N') {
					this.formdatajz.jianmzcsyzt = null;
				}
			},
			ContentsSettingdiag: function(indexVal, oldVal) {
				if (indexVal) {
					this.$nextTick(() => {
						this.tableDatabody.map((item) => {
							item.axiotx = false;
							if (item.shifxz == 1 && item.shuizMc == '增值税') {
								this.radio1 = item;
							}
							if (item.shifxz == 1 && item.shuizMc == '财务报表') {
								this.radio3 = item;
							}
							if (item.shifxz == 1 && item.shuizMc == '企业所得税') {
								this.radio2 = item;
							}
							if (item.shifxz == 1 && item.shuizMc == '残保金') {
								this.radio4 = item;
							}
							if (item.shifxz == 1 && item.shuizMc == '文化建设费') {
								this.radio5 = item;
							}
							if (item.shifxz == 1 && item.shuizMc == '通用申报') {
								this.radio6 = item;
							}
							if (item.shifxz == 1 && item.shuizMc == '消费税') {
								this.radio9 = item;
							}
						});
					});
				}
			}
		},
		created() {},
		filters: {
			timeget: function(value) {
				if (value != null) {
					let time = [];
					value.split(',').map((item) => {
						if (item == '4') {
							time.push('年');
						} else if (item == '3') {
							time.push('半年');
						} else if (item == '2') {
							time.push('季');
						} else if (item == '1') {
							time.push('月');
						} else if (item == '0') {
							time.push('次');
						}
					});
					return time.join(',');
				}
			}
		},
		methods: {
			
			getProtocolNumberData(){
				let comapnyId = this.tableDatabody[0].ides;
				let id = this.protocolNumberFormData.id;
				this.protocolNumberFormData.companyId = comapnyId;
				let param = JSON.stringify(this.protocolNumberFormData);
				if ('' == id || null == id){
					tripartite_agreement_save(param).then(res => {
						if (res.data.code == 1) {
							this.$message.success("新增成功！");
							this.tripartiteAgreementQuery(this.tableDatabody[0].ides);
							this.editProtocolNumber =false;
						} else {
							this.$message.error(res.data.msg);
						}
					})
					
				}
				else {
					tripartite_agreement_update(param).then(res => {
						if (res.data.code == 1) {
							this.$message.success("修改成功！");
							this.tripartiteAgreementQuery(this.tableDatabody[0].ides);
							this.editProtocolNumber =false;
						} else {
							this.$message.error(res.data.msg);
						}
					})
				}
			
			},
			editProtocolNumberMonth(){
				this.$refs['refProtocolNumberForm'].submitForm()
			},
			deleteTripartiteAgreement(e) {
				tripartite_agreement_delete({
					id: e.id
				}).then(res => {
					if (res.data.code == 1) {
						this.$message.success("删除成功！");
						let size = this.WHtableData.length-1;
                        if (0 == size){
							this.XYpagination.pageNum = 1 == this.XYpagination.pageNum ? 1: this.XYpagination.pageNum-1;
						}
						this.tripartiteAgreementQuery(this.tableDatabody[0].ides);
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			updateTripartiteAgreement(e) {
				let param = JSON.parse(JSON.stringify(e));
				this.protocolNumberFormData.id = param.id;
				this.protocolNumberFormData.protocolNumber = param.protocolNumber;
				this.protocolNumberFormData.isDefault = param.isDefault;
				this.editProtocolNumber = true;
			},
		addProtocolNumber(){
		 Object.keys(this.protocolNumberFormData).map(key => (this.protocolNumberFormData[key] = ""));
		this.editProtocolNumber = true;
		},
			Congc() {
				this.formdatajz.jianmzcsyzt = ""
				this.formdatajz.benqsfsyxwqy = ""
				this.formdatajz.shifzzsxgmnsr = ""
			},
			clickitemdataType(e, key) {
				e === this.formdataGeneralD[key] ? this.formdataGeneralD[key] = '' : this.formdataGeneralD[key] = e
			},
			clickGeneralx(e) {
				e === this.radio7 ? this.radio7 = '' : this.radio7 = e
			},
			assConfiguration() {
				queryDiaLogInfo({
					companyId: this.tableDatabody[0].ides
				}).then((res) => {
					if (res.data.code == 1) {
						this.assist = true;
						res.data.data.map((item) => {
							item.taxDialogOptionList.map((item1) => {
								if (item1.checked) {
									item.checked = item1.optionCode;
									this.funx(item1);
								}
							});
						});
						this.asslist = res.data.data
					}
				});
			},
			funx(value) {
				if (value.children.length > 0) {
					value.children.map((item) => {
						if (item.checked) {
							value.checked = item.optionCode;
							this.funx(item);
						}
					});
				}
			},
			
			tripartiteAgreementQuery(companyId) {
				let params = {}
				params.current = this.XYpagination.pageNum;
				params.size = this.XYpagination.pageSize;
				params.companyId = companyId;
				tripartite_agreement_query(params).then(res => {
					if (res.data.code == 1) {
						this.XYpagination.total = res.data.data.total;
						this.WHtableData = res.data.data.records;
					}
				})
			},
			
			nextpz() {
				this.assvalue = [];
				this.asslist.map((item) => {
					item.taxDialogOptionList.map((item1) => {
						if (item1.children.length != 0) {
							this.chanegs(item1);
						} else {
							if (item.checked == item1.optionCode) {
								if (item1.memoJson) {
									this.assvalue.push({
										optionCode: item1.optionCode,
										memoJson: item1.memoJson
									});
								} else {
									this.assvalue.push({
										optionCode: item1.optionCode
									});
								}
							}
						}
					});
				});
				let params = {
					companyId: this.tableDatabody[0].ides,
					optionCodeList: [...this.assvalue]
				};
				console.log(this.assvalue)
				saveDiaLogInfo(params).then((res) => {
					if (res.data.code == 1) {
						this.$message.success('配置成功')
						this.assist = false
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			chanegs(value) {
				for (let index = 0; index < value.children.length; index++) {
					if (value.checked == value.children[index].optionCode) {
						if (!value.children[index].children || value.children[index].children.length == 0) {
							if (value.children[index].memoJson) {
								return this.assvalue.push({
									optionCode: value.children[index].optionCode,
									memoJson: value.children[index].memoJson
								});
							} else {
								return this.assvalue.push({
									optionCode: value.children[index].optionCode,
								});
							}
						} else {
							this.chanegs(value.children[index]);
						}

					}
				}
			},
			forchoosemove(index) {
				if (this.choosedjindex != index) {
					this.choosedjindex = index;
				}
			},
			foraddup(index) {
				let item = {};
				this.tableDatayhs.splice(index, 0, item);
			},
			foradddown(index) {
				let item = {};
				this.tableDatayhs.splice(index + 1, 0, item);
			},
			forremove(item, index) {
				if (this.tableDatayhs.length == 1) {
					this.tableDatayhs = [{}];
				} else {
					this.tableDatayhs.splice(index, 1);
				}
			},


			foraddupxfs(index) {
				let item = {};
				this.tableDataxfs.splice(index, 0, item);
			},
			foradddownxfs(index) {
				let item = {};
				this.tableDataxfs.splice(index + 1, 0, item);
			},
			forremovexfs(item, index) {
				if (this.tableDataxfs.length == 1) {
					this.tableDataxfs = [{}];
				} else {
					this.tableDataxfs.splice(index, 1);
				}
			},

			changeRadio(val) {
				if (val.shuizMc == '增值税') {
					this.radio1 = this.radio1 == val ? '' : val;
					this.radioKey = !this.radioKey;
				}
				if (val.shuizMc == '财务报表') {
					this.radio3 = this.radio3 == val ? '' : val;
					this.radioKey2 = !this.radioKey2;
				}
				if (val.shuizMc == '企业所得税') {
					this.radio2 = this.radio2 == val ? '' : val;
					this.radioKey1 = !this.radioKey1;
				}
				if (val.shuizMc == '残保金') {
					this.radio4 = this.radio4 == val ? '' : val;
					this.radioKey3 = !this.radioKey3;
				}
				if (val.shuizMc == '文化建设费') {
					this.radio5 = this.radio5 == val ? '' : val;
					this.radioKey4 = !this.radioKey4;
				}
				if (val.shuizMc == '通用申报') {
					this.radio6 = this.radio6 == val ? '' : val;
					this.radioKey5 = !this.radioKey5;
				}
				if (val.shuizMc == '消费税') {
					this.radio9 = this.radio9 == val ? '' : val;
					this.radioKey6 = !this.radioKey6;
				}
			},
			nextjz() {
				let params = {
					id: this.formdatajz.id,
					benqsfsyxwqy: this.formdatajz.benqsfsyxwqy,
					companyId: this.tableDatabody[0].ides,
					shifzzsxgmnsr: this.formdatajz.shifzzsxgmnsr
				};
				if (this.formdatajz.benqsfsyxwqy == 'Y') {
					params.jianmzcsyzt = this.formdatajz.jianmzcsyzt;
				}
				editCcxwsPolicy(params).then((res) => {
					if (res.data.code == 1) {
						this.jzdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			outthree() {
				let params = {
					companyId: this.tableDatabody[0].ides
				};
				queryCcxwsPolicy(params).then((res) => {
					if (res.data.code == 1) {
						this.jzdiag = true;
						if (res.data.data == null) {
							this.formdatajz = {
								jianmzcsyzt: null,
								benqsfsyxwqy: null,
								shifzzsxgmnsr: null
							};
						} else {
							if (res.data.data.benqsfsyxwqy == 'N') {
								res.data.data.jianmzcsyzt = null;
							}
							this.formdatajz = res.data.data;
						}
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			queryTripartiteAgreement() {
				this.ConfigureProtocolNumber = true;
				this.tripartiteAgreementQuery(this.tableDatabody[0].ides);
			},
			sizechange(e) {
				this.XYpagination.pageSize = e;
				this.tripartiteAgreementQuery(this.tableDatabody[0].ides);
			},
			currentChange(e) {
				this.XYpagination.pageNum = e;
				this.tripartiteAgreementQuery(this.tableDatabody[0].ides);
			},
			nextfc() {
				let tonext = false;
				let fccztdDetail = [];
				if (this.shuiBtype == 'cztds') {
					this.tableDatahouse.cztd.map((item) => {
						fccztdDetail.push({
							shuikssqzMonth: item.shuikssqzMonth,
							shuikssqqMonth: item.shuikssqqMonth,
							shenbq: item.shenbq,
							type: item.type
						});
					});
					tonext = this.tableDatahouse.cztd.length == 0 ? true : false;
				} else {
					this.tableDatahouse.fccz.map((item) => {
						fccztdDetail.push({
							shuikssqzMonth: item.shuikssqzMonth,
							shuikssqqMonth: item.shuikssqqMonth,
							shenbq: item.shenbq,
							type: item.type
						});
					});
					this.tableDatahouse.fccj.map((item) => {
						fccztdDetail.push({
							shuikssqzMonth: item.shuikssqzMonth,
							shuikssqqMonth: item.shuikssqqMonth,
							shenbq: item.shenbq,
							type: item.type
						});
					});
					tonext = this.tableDatahouse.fccj.length == 0 && this.tableDatahouse.fccz.length == 0 ? true : false;
				}
				if (fccztdDetail.length > 0 || tonext) {
					for (let a = 0; a < fccztdDetail.length; a++) {
						let arr = Object.keys(fccztdDetail[a]);
						for (let b = 0; b < arr.length; b++) {
							if (fccztdDetail[a][arr[b]] == '' || fccztdDetail[a][arr[b]] == null) {
								return this.$message.error('请把填写完整');
							}
						}
					}
				} else {
					return this.$message.error('请把填写完整');
				}
				let org = false;
				fccztdDetail.map((item, index) => {
					fccztdDetail.map((item1, index1) => {
						if (
							item1.shuikssqzMonth == item.shuikssqzMonth &&
							item1.shuikssqqMonth == item.shuikssqqMonth &&
							item1.type == item.type &&
							index1 != index
						) {
							org = true;
						}
					});
				});
				if (org) {
					return this.$message.error('申报所属期的税款所属期重合，请重新选择');
				}
				let params = {
					companyId: this.tableDatabody[0].ides,
					shuibNameCode: this.ids.shuiBNameCode,
					shuiBid: this.stacid,
					shifbs: this.shifbs,
					fccztdDetail
				};
				let sfshenbzq = false;
				editfccztds(params).then((res) => {
					if (res.data.code == 1) {
						let shenbzqx = [];
						this.tableDatabody[this.listou.index].shifbs = this.shifbs;
						fccztdDetail.map((item1) => {
							if (item1.shenbq != '') {
								shenbzqx.push(item1.shenbq);
							}
						});
						shenbzqx = [...new Set(shenbzqx)];
						this.tableDatabody[this.listou.index].shenbzq = shenbzqx.join(',');
						this.updatehouse = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			deletes(e, index) {
				e.splice(index, 1);
			},
			addfc(e) {
				if (e == 'cztd') {
					this.tableDatahouse.cztd.push({
						shuikssqzMonth: '',
						shuikssqzMonth: '',
						shenbq: this.suosq,
						type: 'cztds'
					});
				} else if (e == 'fccj') {
					this.tableDatahouse.fccj.push({
						shuikssqzMonth: '',
						shuikssqzMonth: '',
						shenbq: this.suosq,
						type: 'ccxwfccj'
					});
				} else if (e == 'cbj') {
					this.tableDatahouse.cbj.push({
						shuikssqzMonth: '',
						shuikssqzMonth: '',
						shenbq: this.suosq,
						type: 'cbj'
					});
				} else {
					this.tableDatahouse.fccz.push({
						shuikssqzMonth: '',
						shuikssqzMonth: '',
						shenbq: this.suosq,
						type: 'ccxwfccz'
					});
				}
			},
			nextqy() {
				if (this.updatecompanyformdata.huizsb == 2 && !this.listou.radio1) {
					return this.$message.error('汇总申报为分支机构，汇总机构需选择。');
				}
				this.updatecompanyformdata.shenbzq = [...new Set(this.updatecompanyformdata.shenbzq)];
				if (this.updatecompanyformdata.shenbzq.length != 0) {
					let zzsDetailCompanys = [];
					this.shenbaodata.map((item) => {
						if (item.detailId) {
							item.detailId = item.isok;
							zzsDetailCompanys.push({
								...item
							});
						}
					});
					zzsDetailCompanys.map((item) => {
						delete item.isok;
						delete item.list;
					});
					let params = {
						companyId: this.tableDatabody[0].ides,
						shenbzq: this.updatecompanyformdata.shenbzq.join(','),
						shifbs: this.updatecompanyformdata.test6,
						shuiBid: this.stacid,
						huizsb: this.updatecompanyformdata.huizsb,
						huizId: this.listou.radio1,
						zzsDetailCompanys
					};

					taxeditqysds(params).then((res) => {
						if (res.data.code == 1) {
							this.tableDatabody.map((item) => {
								if (item.shuibId == this.stacid) {
									item.shenbzq = this.updatecompanyformdata.shenbzq.join(',');
									item.shifbs = this.updatecompanyformdata.test6;
									item.huizsb = this.updatecompanyformdata.huizsb;
									item.huizId = this.listou.radio1;
								}
							});
							this.updatecompanydiag = false;
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.$message.error('请至少选择一个申报周期');
				}
			},
			nextGeneralx() {
				this.tableDatabody[this.listou.index].shifbs = this.radio8;
				this.tableDatabody[this.listou.index].shenbzq = this.radio7;
				let params = {
					companyId: this.tableDatabody[0].ides,
					shuiBid: this.stacid,
					shenbzq: this.radio7,
					shifbs: this.radio8
				};
				editcbj(params).then((res) => {
					if (res.data.code == 1) {
						this.Generalx = false
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			nexthzjg() {
				this.hzdiag = false;
				this.listou.radio1 = this.listou.radio2;
				this.tableDatahz.map((item) => {
					if (item.id == this.listou.radio2) {
						this.listou.input = item.nsrmc;
					}
				});
			},
			//汇总申报
			somechange() {
				if (this.listou.huizsb != 2) {
					this.listou.radio2 = '';
					this.listou.radio1 = '';
					this.listou.input = '';
				}
			},
			//汇总机构选择
			clickitem(e) {
				e === this.listou.radio2 ? (this.listou.radio2 = '') : (this.listou.radio2 = e);
				if (this.listou.radio2 == '') {
					this.listou.radio1 = '';
					this.listou.input = '';
				}
			},
			//获取对总机构
			async huoqdzjg() {
				let huo = await this.huoqdzjgs();
				if (huo) {
					this.hzdiag = true;
				}
			},
			//获取对总机构获取
			huoqdzjgs() {
				return new Promise((resolve, reject) => {
					let params = {
						companyId: this.tableDatabody[0].ides,
						shuibId: this.shui.sbid
					};
					getHuizjigou(params).then((res) => {
						if (res.data.code == 1) {
							this.tableDatahz = res.data.data.companys.records;
							if (this.listou.radio1 != '' && this.listou.radio1 != null) {
								this.listou.radio2 = parseFloat(this.listou.radio1);
								this.tableDatahz.map((item) => {
									if (item.id == this.listou.radio1) {
										this.listou.input = item.nsrmc;
									}
								});
							} else {
								this.listou.radio1 = '';
								this.listou.radio2 = '';
								this.listou.input = '';
							}
							// this.nexthzjg()
							resolve(true);
						} else {
							this.$message.error(res.data.msg);
						}
					});
				});
			},
			nextzz() {
				if (this.listou.time.length != 0) {
					let zzsDetailCompanys = [];
					this.sbboxdata.map((item) => {
						if (item.detailId) {
							// item.detailId = item.isok
							zzsDetailCompanys.push({
								...item
							});
						}
					});
					if (zzsDetailCompanys.length == 0) {
						this.$message.error('税表至少需要选择一个');
						return;
					}
					zzsDetailCompanys.map((item) => {
						if (item.detailId) {
							if (item.isok) {
								item.detailId = item.isok;
							} else {
								item.detailId = item.shuiBDetailId;
							}
						}
					});
					zzsDetailCompanys.map((item) => {
						delete item.isok;
					});
					if (this.title == '编辑消费税') {
						let iszm = false;
						this.tableDataxfs.forEach(v => {
							if (v.option && v.option.length != 0 && this.$emptyandnull(v.zm)) {
								iszm = true
							}
						})
						if (iszm) {
							this.$message.error('请选择子目');
							return;
						}
					}
					let params = {
						companyId: this.tableDatabody[0].ides,
						shenbzq: this.listou.time.join(','),
						shifbs: this.listou.radio,
						huizsb: this.listou.huizsb,
						shuiBid: this.stacid,
						zzsDetailCompanys
					};
					if (this.listou.radio1 && this.listou.radio1 != '') {
						params.huizId = this.listou.radio1;
					} else {
						params.huizId = '0';
					}
					if (this.listou.huizsb == 2 && !this.listou.radio1) {
						return this.$message.error('汇总申报为分支机构，汇总机构需选择。');
					}
					editzzs(params).then((res) => {
						if (res.data.code == 1) {
							if (this.title == '编辑消费税') {
								params.xfpInfoItemInPutDTOList = this.tableDataxfs
								save_info(params).then(res1 => {
									if (res1.data.code == 1) {
										this.tableDatabody[this.listou.index].shenbzq = this.listou.time
											.join(','); //d
										this.tableDatabody[this.listou.index].shifbs = this.listou
											.radio; //d
										this.tableDatabody[this.listou.index].huizsb = this.listou
											.huizsb; //d
										this.tableDatabody[this.listou.index].huizId = this.listou
											.huizsb; //d
										this.updatezzsdiag = false;
									} else {
										this.$message.error(res1.data.msg);
									}
								})
							} else {
								this.tableDatabody[this.listou.index].shenbzq = this.listou.time.join(','); //d
								this.tableDatabody[this.listou.index].shifbs = this.listou.radio; //d
								this.tableDatabody[this.listou.index].huizsb = this.listou.huizsb; //d
								this.tableDatabody[this.listou.index].huizId = this.listou.huizsb; //d
								this.updatezzsdiag = false;
							}

						} else {
							this.$message.error(res.data.msg);
						}
					});

				} else {
					this.$message.error('请至少选择一个申报周期');
				}
			},
			nextsb() {
				let shuiBids = [];
				let shuiZids = [];
				this.tableDatabody.map((item) => {
					if (item.shuizMc == '财产行为税') {
						if (item.shifxz == 1) {
							shuiBids.push(item.shuibId);
						}
					}
					if (item.shuizMc == "通用申报") {
						if (item.shifxz == 1) {
							shuiBids.push(item.shuibId)
						}
					}
				});
				if (this.radio1 != {}) {
					shuiZids.push(this.radio1.shuizId);
					shuiBids.push(this.radio1.shuibId);
				}
				if (this.radio2 != {}) {
					shuiZids.push(this.radio2.shuizId);
					shuiBids.push(this.radio2.shuibId);
				}
				if (this.radio3 != {}) {
					shuiZids.push(this.radio3.shuizId);
					shuiBids.push(this.radio3.shuibId);
				}
				if (this.radio4 != {}) {
					shuiZids.push(this.radio4.shuizId);
					shuiBids.push(this.radio4.shuibId);
				}
				if (this.radio5 != {}) {
					shuiZids.push(this.radio5.shuizId);
					shuiBids.push(this.radio5.shuibId);
				}
				if (this.radio9 != {}) {
					shuiZids.push(this.radio9.shuizId);
					shuiBids.push(this.radio9.shuibId);
				}
				for (let a = 0; a < shuiBids.length; a++) {
					if (shuiBids[a] == null || shuiBids[a] == undefined) {
						shuiBids.splice(a, 1);
						a--;
					}
				}
				for (let a = 0; a < shuiZids.length; a++) {
					if (shuiZids[a] == null || shuiZids[a] == undefined) {
						shuiZids.splice(a, 1);
						a--;
					}
				}
				let params = {
					shuiBids,
					shuiZids,
					companyId: this.tableDatabody[0].ides
				};
				shenbaoContent(params).then((res) => {
					if (res.data.code == 1) {
						this.$emit('closediag', '');
						this.$message.success('修改成功');
						this.ContentsSettingdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			out() {
				this.$emit('closediag', '');
				this.ContentsSettingdiag = false;
			},
			changeradio() {},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 0) {
					return {
						rowspan: row.span > 0 ? row.span : 0,
						colspan: row.span > 0 ? 1 : 0
					};
				} else {
					return [1, 1];
				}
			},
			closediag() {
				this.$emit('closediag', '');
			},
			nextcw() {
				let cwbbDetailCompanys = [];
				this.tableDatacw.map((item) => {
					cwbbDetailCompanys.push({
						...item
					});
				});
				let sfzq = false;
				let sfxz = false;
				this.tableDatacw.map((item) => {
					if (item.shiftx && item.shiftx != 0) {
						sfxz = true;
						if (item.time.length == 0) {
							sfzq = true;
						}
					}
				});
				if (!sfxz) {
					return this.$message.error('请至少选择一个报表');
				}
				if (sfzq) {
					return this.$message.error('请至少选择一个申报周期');
				}
				cwbbDetailCompanys.map((item, index) => {
					if (item.shiftx == true) {
						item.shiftx = '1';
					} else {
						item.shiftx = '0';
					}
					item.shenbzq = item.time.join(',');
					delete item.time;
				});

				let params = {
					companyId: this.tableDatabody[0].ides,
					shifbs: this.listou.radio,
					shuiBid: this.stacid,
					cwbbDetailCompanys: cwbbDetailCompanys
				};
				editcwbb(params).then((res) => {
					if (res.data.code == 1) {
						let shenbzqx = [];
						cwbbDetailCompanys.map((item) => {
							if (item.shenbzq != '') {
								item.shenbzq.split(',').map((item2) => {
									shenbzqx.push(item2);
								});
							}
						});
						shenbzqx = [...new Set(shenbzqx)];
						this.tableDatabody[this.listou.index].shenbzq = shenbzqx.join(',');
						this.tableDatabody[this.listou.index].shifbs = this.listou.radio;
						this.updatecwdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			zzssb(e) {
				if (e.reportName == '附表四') {
					if (!e.detailId) {
						e.jiaJDkBl = null;
					}
				}
			},
			options(e, value) {
				this.tableDatayhs.map((item, index) => {
					if (index != this.tableDatayhs.length - 1) {
						if (item.zim == value.zim && e != index) {
							this.$message.error('相同的子目不可以维护多条');
							Object.keys(this.tableDatayhs[this.tableDatayhs.length - 1]).map((key) => {
								if (key != 'sfzim') {
									this.tableDatayhs[this.tableDatayhs.length - 1][key] = '';
								}
							});
							return;
						}
					}
				});
				this.tableDatayhs[e].option.map((item, index) => {
					if (item.zszmDm == this.tableDatayhs[e].zim) {
						this.tableDatayhs[e].zimName = item.zszmMc;
						this.tableDatayhs[e].shuil = item.sl1;
					}
				});
				this.$forceUpdate();
			},
			changeoptionxfs(e, index) {
				e.zm = ""
				let value = this.optionxfs.filter(v => v.value == e.pm)[0]
				e.option = value.children
				if (!e.option) {
					e.shuil = value.shuil
					e.type = value.type
				} else {
					e.shuil = ""
					e.type = ""
				}
			},
			optionsxfs(e) {
				this.isshas = false
				e.shuil = e.option.filter(v => v.value == e.zm)[0].shuil
				e.type = e.option.filter(v => v.value == e.zm)[0].type
				this.isshas = true
			},
			option(e, index) {
				e.zim = '';
				e.zimName = '';

				this.yhs[0].map((item) => {
					if (item.zspmDm == this.tableDatayhs[index].shuim) {
						this.tableDatayhs[index].option = [];
						this.tableDatayhs[index].shuimName = item.zspmMc;
						if (e.shuimName != '产权转移书据') {
							this.tableDatayhs[index].shuil = item.sl1;
						} else {
							this.tableDatayhs[index].shuil = '';
						}
						if (item.zszm.length != 0) {
							item.zszm.map((item2) => {
								this.tableDatayhs[index].option.push(item2);
							});
							this.tableDatayhs[index].sfzim = false;
						} else {
							this.tableDatayhs[index].sfzim = true;
						}
					}
				});
			},
			nextGeneralD() {
				let params = JSON.parse(JSON.stringify(this.formdataGeneralD));
				params.companyId = this.tableDatabody[0].ides;
				params.shuiBid = this.stacid;
				params.shenbzqDfsljsjj = params.shenbzqDfsljsjj;
				params.shenbzqGhjfbw = params.shenbzqGhjfbw;
				params.shenbzqCzljclf = params.shenbzqCzljclf;
				preservationty(params).then((res) => {
					if (res.data.code == 1) {
						let arr = ['shenbzqDfsljsjj', 'shenbzqGhjfbw', 'shenbzqCzljclf'];
						arr.map((item) => {
							if (!this.formdataGeneralD[item]) {
								this.formdataGeneralD[item] = [];
							}
						});
						let shenbzqx = [
							...this.formdataGeneralD.shenbzqDfsljsjj,
							...this.formdataGeneralD.shenbzqGhjfbw,
							...this.formdataGeneralD.shenbzqCzljclf
						];
						shenbzqx = [...new Set(shenbzqx)];
						this.tableDatabody[this.listou.index].shenbzq = shenbzqx.join(',');
						this.tableDatabody[this.listou.index].shifbs = this.formdataGeneralD.shifbs;
						this.GeneralD = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			// nextDisabilityI() {
			//     this.tableDatabody[this.listou.index].shifbs = this.tableDatacb[0].shifbs;
			//     this.tableDatabody[this.listou.index].shenbzq = this.DisabilityItime;
			//     let params = {
			//         companyId: this.tableDatabody[0].ides,
			//         shuiBid: this.stacid,
			//         shenbzq: this.DisabilityItime,
			//         shifbs: this.tableDatacb[0].shifbs
			//     };
			//     editcbj(params).then((res) => {
			//         if (res.data.code == 1) {
			//             this.DisabilityI = false;
			//         } else {
			//             this.$message.error(res.data.msg);
			//         }
			//     });
			// },
			nextDisabilityI() {
				// this.tableDatabody[this.listou.index].shifbs = this.tableDatacb[0].shifbs;
				// this.tableDatabody[this.listou.index].shenbzq = this.DisabilityItime;
				let fccztdDetail = [];
				let tonext = false
				this.tableDatahouse.cbj.map((item) => {
					fccztdDetail.push({
						shuikssqzMonth: item.shuikssqzMonth,
						shuikssqqMonth: item.shuikssqqMonth,
						shenbq: item.shenbq,
						type: item.type
					});
				});
				tonext = this.tableDatahouse.cbj.length == 0 ? true : false;
				if (fccztdDetail.length > 0 || tonext) {
					for (let a = 0; a < fccztdDetail.length; a++) {
						let arr = Object.keys(fccztdDetail[a]);
						for (let b = 0; b < arr.length; b++) {
							if (fccztdDetail[a][arr[b]] == '' || fccztdDetail[a][arr[b]] == null) {
								return this.$message.error('请把填写完整');
							}
						}
					}
				} else {
					return this.$message.error('请把填写完整');
				}
				let org = false;
				fccztdDetail.map((item, index) => {
					fccztdDetail.map((item1, index1) => {
						if (
							item1.shuikssqzMonth == item.shuikssqzMonth &&
							item1.shuikssqqMonth == item.shuikssqqMonth &&
							item1.type == item.type &&
							index1 != index
						) {
							org = true;
						}
					});
				});
				if (org) {
					return this.$message.error('申报所属期的税款所属期重合，请重新选择');
				}
				let params = {
					companyId: this.tableDatabody[0].ides,
					shuiBid: this.stacid,
					shenbzq: this.DisabilityItime,
					// shifbs: this.tableDatacb[0].shifbs,
					shifbs: this.shifbs,
					fccztdDetail: fccztdDetail
				};
				editfccztds(params).then((res) => {
					if (res.data.code == 1) {
						this.DisabilityI = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			nextConstructionCCU() {
				this.shenbaodata.map((item) => {
					delete item.isok;
					if (item.detailId) {
						item.detailId = item.id;
					} else {
						item.detailId = null;
					}
				});
				let params = JSON.parse(JSON.stringify(this.formdataConstruction));
				params.dictList = this.shenbaodata;
				params.companyId = this.tableDatabody[0].ides;
				params.shuiBid = this.stacid;
				if (params.shenbzq == null || params.shenbzq.length == 0) {
					params.shenbzq = '';
				} else {
					params.shenbzq = params.shenbzq.join(',');
				}
				preservationwhsy(params).then((res) => {
					if (res.data.code == 1) {
						this.tableDatabody[this.listou.index].shifbs = this.formdataConstruction.shifbs;
						this.tableDatabody[this.listou.index].shenbzq = this.formdataConstruction.shenbzq.join(
							',');
						this.ConstructionCCU = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			nextnew() {
				let yhsDetailCompanys = [];
				let yhs = false;
				this.tableDatayhs.map((item) => {
					if (
						item.shuimName != '产权转移书据' ?
						item.shuim == '' || item.shuimName == '' || (!item.shenbqxlx && this.tableDatayhs.length !=
							1) :
						item.shuil == ''
					) {
						yhs = true;
					}
					if (JSON.stringify(item) !== '{}' && item.shuil) {
						yhsDetailCompanys.push({
							shuil: item.shuil,
							shuim: item.shuim,
							shuimName: item.shuimName,
							shenbqxlx: item.shenbqxlx,
							zim: item.zim,
							zimName: item.zimName
						});
					}
				});
				if (yhs) {
					return this.$message.error('请把信息补充完整');
				}
				yhsDetailCompanys.map((item) => {
					delete item.sfzim;
				});
				let params = {
					companyId: this.tableDatabody[0].ides,
					shifbs: this.listou.radio,
					shuiBid: this.stacid,
					yhsDetailCompanys
				};
				edityhs(params).then((res) => {
					if (res.data.code == 1) {
						let shenbzqx = [];
						this.tableDatabody.map((item) => {
							this.tableDatabody[this.listou.index].shifbs = this.listou.radio;
							yhsDetailCompanys.map((item) => {
								if (item.shenbqxlx != '') {
									item.shenbqxlx.split(',').map((item2) => {
										shenbzqx.push(item2);
									});
								}
							});
							if (item.shuibId == this.stacid) {
								shenbzqx = [...new Set(shenbzqx)];
								item.shenbzq = shenbzqx.join(',');
								item.shifbs = this.radio.option5;
							}
						});
						this.updateyhsdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			nexthj() {
				let fccztdDetailCompanys = [];
				this.tableDatahj.map((item) => {
					fccztdDetailCompanys.push({
						...item
					});
				});
				fccztdDetailCompanys.map((item) => {
					item.shenbzq = item.time.join(',');
					delete item.time;
					if (item.shiftx) {
						item.shiftx = '1';
					} else {
						item.shiftx = '0';
					}
				});
				let params = {
					companyId: this.tableDatabody[0].ides,
					shuibNameCode: this.ids.shuibNameCode,
					shuiBid: this.ids.shuibId,
					fccztdDetailCompanys
				};
				let sfshenbzq = false;
				fccztdDetailCompanys.map((item) => {
					if (item.shenbzq == '') {
						sfshenbzq = true;
					}
				});
				if (sfshenbzq) {
					return this.$message.error('请至少选择一个申报周期');
				}
				edithbs(params).then((res) => {
					if (res.data.code == 1) {
						let shenbzqx = [];
						fccztdDetailCompanys.map((item1) => {
							this.tableDatabody[this.listou.index].shifbs = item1.shifbs;
							if (item1.shenbzq != '') {
								item1.shenbzq.split(',').map((item2) => {
									shenbzqx.push(item2);
								});
							}
						});
						shenbzqx = [...new Set(shenbzqx)];
						this.tableDatabody[this.listou.index].shenbzq = shenbzqx.join(',');

						this.updatehjdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			indexshui(params) {
				taxeditzzs(params).then((res) => {
					if (res.data.code == 1) {} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			changehuizsb(e) {
				if (e.value == 2) {
					if (this.updatecompanyformlist.length < 5) {
						this.updatecompanyformlist.splice(4, 0, {
							prop: 'test8',
							label: '对应汇总机构',
							type: 'select',
							slot: true
						});
					}
					this.shenbaodata.map((item) => {
						if (item.reportName == '企业所得税汇总纳税分支机构所得税分配表') {
							item.list = true;
							item.detailId = '';
						}
					});
				} else {
					this.updatecompanyformlist.splice(4, 1);
					this.listou.radio1 = '';
					this.listou.radio2 = '';
					this.listou.input = '';
					this.shenbaodata.map((item) => {
						if (e.value == 1) {
							if (item.reportName == '企业所得税汇总纳税分支机构所得税分配表') {
								item.list = false;
							}
						} else {
							if (item.reportName == '企业所得税汇总纳税分支机构所得税分配表') {
								item.list = true;
								item.detailId = '';
							}
						}
					});
				}
			},
			fun(e) {
				e.map((item2) => {
					if (item2.shiftx == 1) {
						item2.shiftx = true;
					} else {
						item2.shiftx = false;
					}
					if (item2.shenbzq != '' && item2.shenbzq != null) {
						item2.time = item2.shenbzq.split(',');
					} else {
						item2.time = [];
					}
				});
			},
			forupdate(out, index) {
				this.listou.index = out.index;
				this.ids = {
					shuiBNameCode: index.shuiBNameCode,
					shuibId: index.shuibId
				};
				let params = {
					companyId: this.tableDatabody[0].ides,
					shuiBNameCode: index.shuiBNameCode,
					shuibId: index.shuibId
				};
				if (index.shifbs == null) {
					this.listou.radio = '0';
				} else {
					this.listou.radio = index.shifbs;
				}
				this.shui.sbid = index.shuibId;
				this.shui.szid = index.shuizId;
				this.stacid = index.shuibId;
				this.radio.option6 = index.reportName;
				if (index.shuizMc == '增值税' || index.shuizMc == '消费税') {
					if (index.shenbzq != '' && index.shenbzq != null) {
						this.listou.time = index.shenbzq.split(',');
					}
					this.sbboxdata = [];
					zzs(params).then((res) => {
						if (res.data.code == 1) {
							this.listou.radio = index.shifbs;
							this.sbboxdata = res.data.data;
							this.listou.huizsb = index.huizsb;
							this.listou.radio1 = index.huizId;
							this.sbboxdata.map((item) => {
								if (item.detailId) {
									item.isok = item.detailId;
									item.detailId = true;
								}
							});
							this.title = "编辑" + index.shuizMc;
							if (index.shuizMc == '消费税') {
								get_info(params).then((res1) => {
									if (res1.data.code == 1) {
										if (res1.data.data.length != 0) {
											this.tableDataxfs = res1.data.data.map(v => {
												v.option = this.optionxfs.filter(vv => vv.value ==
													v.pm)[0].children
												return v
											})
										} else {
											this.tableDataxfs = [{}];
										}
										this.updatezzsdiag = true;
										this.huoqdzjgs();
									} else {
										this.$message.error(res1.data.msg);
									}
								})

							} else {
								this.updatezzsdiag = true;
								this.huoqdzjgs();
							}
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.shuizMc == '企业所得税') {
					this.updatecompanyformdata.test6 = index.shifbs;
					if (index.shenbzq != '' && index.shenbzq != null) {
						this.updatecompanyformdata.shenbzq = index.shenbzq;
					}

					this.shenbaodata = [];
					editqysds(params).then((res) => {
						if (res.data.code == 1) {
							this.shenbaodata = res.data.data;
							this.listou.radio1 = index.huizId;
							this.updatecompanyformdata.huizsb = index.huizsb;
							this.changehuizsb({
								value: index.huizsb
							});
							this.updatecompanydiag = true;
							if (this.updatecompanyformdata.huizsb != 2) {
								this.updatecompanyformlist.splice(4, 1);
							}
							this.shenbaodata.map((item) => {
								if (item.detailId) {
									item.isok = item.detailId;
									item.detailId = true;
								}
								if (item.reportName == '企业所得税汇总纳税分支机构所得税分配表' && item.detailId && index
									.huizsb != 1) {
									item.list = true;
								} else if (item.reportName == '企业所得税汇总纳税分支机构所得税分配表' && !item.detailId &&
									index.huizsb == 1) {
									item.list = false;
								}
							});
							if (this.updatecompanyformdata.huizsb == null) {
								this.updatecompanyformdata.huizsb = '';
							}
							this.huoqdzjgs();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.shuizMc == '财务报表') {
					cwbb(params).then((res) => {
						if (res.data.code == 1) {
							this.fun(res.data.data);
							this.tableDatacw = res.data.data;
							this.updatecwdiag = true;
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.reportName == '印花税') {
					this.tableDatabody.map((item) => {
						if (item.reportName == '印花税') {
							this.radio.option5 = item.shifbs;
						}
					});
					sysYhsSm().then((res) => {
						if (res.data.code == 1) {
							this.yhs[0] = res.data.data;
							taxyhs(params).then((res) => {
								if (res.data.code == 1) {
									if (res.data.data.yhsDetailCompanys.length != 0) {
										this.tableDatayhs = res.data.data.yhsDetailCompanys;
										this.tableDatayhs.map((item) => {
											this.yhs[0].map((item2) => {
												if (item.shuim == item2.zspmDm) {
													item.shuil = item.shuil;
													item.option = [];
													if (item2.zszm.length != 0) {
														item2.zszm.map((item3) => {
															item.option.push(
																item3);
														});
													}
												}
											});
										});
										this.tableDatayhs.map((item) => {
											if (item.option.length == 0) {
												item.sfzim = true;
											}
										});
									} else {
										this.tableDatayhs = [{}];
									}
									this.updateyhsdiag = true;
								} else {
									this.$message.error(res.data.msg);
								}
							});
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.reportName == '城镇土地使用税') {
					this.titles = '编辑城镇土地使用税';
					this.tableDatahouse = [];
					fccztd(params).then((res) => {
						if (res.data.code == 1) {
							this.shifbs = this.tableDatabody[this.listou.index].shifbs;
							this.tableDatahouse = res.data.data;
							let time = '';
							this.updatehouse = true;
							this.shuiBtype = 'cztds';
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.reportName == '环境保护税') {
					this.tableDatahj = [];
					hjbhs(params).then((res) => {
						if (res.data.code == 1) {
							this.fun(res.data.data);
							this.tableDatahj = res.data.data;
							this.updatehjdiag = true;
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.reportName == '房产税') {
					this.titles = '编辑房产税';
					this.tableDatahouse = [];
					fccztd(params).then((res) => {
						if (res.data.code == 1) {
							this.shifbs = this.tableDatabody[this.listou.index].shifbs;
							this.tableDatahouse = res.data.data;
							this.updatehouse = true;
							let time = '';
							this.shuiBtype = 'fcs';
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.reportName == '残保金') {
					(this.DisabilityI = true), (this.DisabilityItime = []);
					fccztd(params).then((res) => {
						if (res.data.code == 1) {
							this.tableDatahouse = res.data.data;
							this.shifbs = res.data.data.shifbs;
						} else {
							this.$message.error(res.data.msg);
						}
					});

				} else if (index.reportName == '文化事业建设费') {
					this.ConstructionCCU = true;
					querywhsy(params).then((res) => {
						if (res.data.code == 1) {
							res.data.data.dictList.map((item) => {
								if (item.detailId) {
									item.isok = item.detailId;
									item.detailId = true;
								}
							});
							this.shenbaodata = res.data.data.dictList;
							this.formdataConstruction = res.data.data;
							if (this.formdataConstruction.shenbzq == null) {
								this.formdataConstruction.shenbzq = [];
							} else {
								this.formdataConstruction.shenbzq = this.formdataConstruction.shenbzq.split(',');
							}
							this.formdataConstruction.shifbs = index.shifbs;
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
				// else if(index.reportName == '垃圾处理费' || index.reportName == '工会经费' || index.reportName =='地方水利建设基金'){
				// 	this.GeneralD = true
				// 	this.DisabilityItime = []
				// 	this.tableDataty[0].shifbs = index.shifbs
				// 	this.tableDataty[0].reportName = index.reportName
				// 	let tiem = this.tableDatabody[this.listou.index].shenbzq.split(',')
				// 	this.DisabilityItime.push(...tiem,'','')
				// }
				else if (index.reportName == '通用申报') {
					this.GeneralD = true;
					queryty(params).then((res) => {
						if (res.data.code == 1) {
							this.formdataGeneralD = res.data.data;
							if (this.formdataGeneralD.shenbzqDfsljsjj == null) {
								this.formdataGeneralD.shenbzqDfsljsjj = '';
							} else {
								this.formdataGeneralD.shenbzqDfsljsjj = this.formdataGeneralD.shenbzqDfsljsjj[0];
							}
							if (this.formdataGeneralD.shenbzqGhjfbw == null) {
								this.formdataGeneralD.shenbzqGhjfbw = '';
							} else {
								this.formdataGeneralD.shenbzqGhjfbw = this.formdataGeneralD.shenbzqGhjfbw[0];
							}
							if (this.formdataGeneralD.shenbzqCzljclf == null) {
								this.formdataGeneralD.shenbzqCzljclf = '';
							} else {
								this.formdataGeneralD.shenbzqCzljclf = this.formdataGeneralD.shenbzqCzljclf[0];
							}
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else if (index.reportName == '非税收通用申报') {
					this.Generalx = true
					this.radio7 = this.tableDatabody[this.listou.index].shenbzq
					this.radio8 = this.tableDatabody[this.listou.index].shifbs;
				}
			}
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>